// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","ScreenSMMax":"(max-width: 991px)","Margin":"0.5rem","listWrapper":"Gc453ff","listItem":"Gdde649"};